import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Lecturer from '@/components/lecturer/Lecturer'
import Product from '@/components/product/Product'
import OnLineProduct from '@/components/product/online/OnLineProduct'
import Keywords from '@/components/home/Keywords'
import Userinfo from '@/components/userinfo/Userinfo'
import Apply from '@/components/apply/Apply'
import Testcjw from '@/components/test/Testcjw'
import TestCanvas from '@/components/test/TestCanvas'
import Code from '@/components/lanka/Code'
import Shenling from '@/components/lanka/Shenling'
import Goumai from '@/components/lanka/Goumai'
import Banners from '@/components/home/Banners'
import Classify from '@/components/home/Classify'
import Zhunze from '@/components/Zhunze'
import Kclist from '@/components/youhui/Kclist'
import Youhui from '@/components/youhui/Youhui'
import WebView from '@/components/webview/WebView'
import OpenApply from '@/components/oem/OpenApply'
import Zixun from '@/components/zixun/Zixun'
import ZixunOld from '@/components/zixun/ZixunOld'
import Msgkk from '@/components/miaosha/Msgkk'
import MsApply from "../components/miaosha/MsApply";
import MsNeixun from "../components/miaosha/MsNeixun";
import Zhutui from "../components/zhutui/Zhutui";
import City from "../components/City.vue";
import Task from "../components/task/Task.vue"

/*资料管理*/
import ZiliaoFenlei from "../components/ziliao/ZiliaoFenlei";
import ZiliaoFiles from "../components/ziliao/ZiliaoFiles";
import ZiliaoHeji from "../components/ziliao/ZiliaoHeji";
import ZiliaoLingqu from "../components/ziliao/ZiliaoLingqu";

/*权限管理*/
import PowerList from "../components/power/PowerList";
import PowerRole from "../components/power/PowerRole";
import User from "../components/User";

import Qiandao from "@/components/qiandao/Qiandao";

import _403 from "../components/403"
import Jk214 from '../open/Jk214'
import Mp4Tool from "../components/mp4tool/Mp4Tool.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', name: 'HelloWorld', component: HelloWorld,children:[
        {path: '/home/Banners', name: 'Banners', component: Banners,power:1},
        {path: '/home/Classify', name: 'Classify', component: Classify},
        {path: '/Lecturer', name: 'Lecturer', component: Lecturer},
        {path: '/product/Product', name: 'Product', component: Product},
        {path: '/product/OnLineProduct', name: 'OnLineProduct', component: OnLineProduct},
        {path: '/home/Keywords', name: 'Keywords', component: Keywords},
        {path: '/ucenter/Userinfo', name: 'Userinfo', component: Userinfo},
        {path: '/apply/Apply', name: 'Apply', component: Apply},
        {path: '/Testcjw', name: 'Testcjw', component: Testcjw},
        {path: '/TestCanvas', name: 'TestCanvas', component: TestCanvas},
        {path: '/lanka/code', name: 'Code', component: Code},
        {path: '/lanka/Shenling', name: 'Shenling', component: Shenling},
        {path: '/zhunze', name: 'Zhunze', component: Zhunze},
        {path: '/lanka/goumai', name: 'Goumai', component: Goumai},
        {path: '/youhui/Youhui', name: 'Youhui', component: Youhui},
        {path: '/youhui/Kclist', name: 'Kclist', component: Kclist},
        {path: '/zixun/Zixun', name: 'Zixun', component: Zixun},
        {path: '/zixun/ZixunOld', name: 'ZixunOld', component: ZixunOld},
        {path: '/miaosha/Msgkk', name: 'Msgkk', component: Msgkk},
        {path: '/miaosha/MsApply', name: 'MsApply', component: MsApply},
        {path: '/miaosha/MsNeixun', name: 'MsNeixun', component: MsNeixun},


        {path: '/ziliao/ZiliaoFenlei', name: 'ZiliaoFenlei', component: ZiliaoFenlei},
        {path: '/ziliao/ZiliaoFiles', name: 'ZiliaoFiles', component: ZiliaoFiles},
        {path: '/ziliao/ZiliaoHeji', name: 'ZiliaoHeji', component: ZiliaoHeji},
        {path: '/ziliao/ZiliaoLingqu', name: 'ZiliaoLingqu', component: ZiliaoLingqu},

        {path: '/power/PowerList', name: 'PowerList', component: PowerList},
        {path: '/power/PowerRole', name: 'PowerRole', component: PowerRole},
        {path: '/power/User', name: 'User', component: User},
        {path: '/qiandao/Qiandao', name: 'Qiandao', component: Qiandao},
        {path: '/Zhutui', name: 'Zhutui', component: Zhutui},
        {path: '/City', name: 'City', component: City},
        {path: '/Task', name: 'Task', component: Task},
        {path: '/Mp4Tool', name: 'Mp4Tool', component: Mp4Tool},
    ]},

    {path: '/login', name: 'Login', component: Login},
    {path: '/WebView', name: 'WebView', component: WebView},
    {path: '/OpenApply', name: 'OpenApply', component: OpenApply},
    {path: '/403', name: '_403', component: _403},
    {path: '/Jk214', name: 'Jk214', component: Jk214},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js